export enum LocalePrefix {
  DK = 'dk',
  SE = 'se',
  NO = 'no',
  DE = 'de',
}
